import i18n from "../i18n";

const STATUS_KEYS = {
  400: "badRequest",
  401: "unauthorized",
  403: "forbidden",
  404: "notFound",
  408: "timeout",
  429: "tooMany",
  500: "serverError",
  502: "branchUnreachable",
  503: "branchUnreachable",
  504: "branchUnreachable",
};

/** Hata nesnesinden ya da "Request failed with status code 504" metninden HTTP durumunu çıkarır. */
export function errorStatus(error) {
  if (error === null || error === undefined) return null;
  if (typeof error === "number") return error;
  const status =
    error.status ?? error.response?.status ?? error.statusCode ?? null;
  if (status) return Number(status);
  const text = typeof error === "string" ? error : error.message || "";
  const match = text.match(/status code (\d{3})/i);
  return match ? Number(match[1]) : null;
}

/**
 * Kullanıcıya gösterilecek anlaşılır hata metni.
 * Teknik axios mesajlarını çevirir; zaten anlaşılır olan metinleri olduğu gibi bırakır.
 */
export function humanizeError(error, t = i18n.t.bind(i18n)) {
  if (!error) return t("errors.generic");

  const status = errorStatus(error);
  const text = typeof error === "string" ? error : error.message || "";
  const code = typeof error === "object" ? error.code : undefined;

  if (status && STATUS_KEYS[status]) {
    return t(`errors.${STATUS_KEYS[status]}`, { status });
  }
  if (code === "ERR_NETWORK" || /network error/i.test(text)) {
    return t("errors.network");
  }
  if (code === "ECONNABORTED" || /timeout/i.test(text)) {
    return t("errors.timeout");
  }
  if (/^no results found$/i.test(text)) {
    return t("errors.noResults");
  }
  if (/^request failed/i.test(text) || /^something went wrong$/i.test(text)) {
    return t("errors.generic");
  }
  return text || t("errors.generic");
}
